import './Datenschutz.css';
import {useNavigate} from "react-router-dom";
import {Button} from "@radix-ui/themes";

function Datenschutz() {

    const navigate = useNavigate();

    const onZurueckClick = () => {
        navigate('/');
    }

    const datenschutzContent = (
        <main aria-labelledby="heading-datenschutz">
            <h1 id="heading-datenschutz" className="content-container-header">Datenschutz</h1>
            <div className="datenschutz-content">
                <section aria-labelledby="section-verantwortlicher">
                    <h2 id="section-verantwortlicher">I. Name und Anschrift des
                        Verantwortlichen</h2>
                    <address>Landesamt für Umwelt Rheinland-Pfalz<br/>
                        Kaiser-Friedrich-Straße 7<br/>
                        55116 Mainz / Rhein<br/><br/>
                    </address>
                    Telefon: 06131 - 6033 - 0<br/>
                    Fax: 06131 - 1432966<br/>
                    E-Mail: <a href="mailto:bis-bokat@lfu.rlp.de"
                               aria-label="E-Mail an bis-bokat@lfu.rlp.de senden">bis-bokat@lfu.rlp.de</a><br/>
                    Website: <a href="https://www.lfu.rlp.de" target="_blank"
                                rel="noreferrer">www.lfu.rlp.de</a><p></p>
                </section>

                <section aria-labelledby="section-datenschutzbeauftragter">
                    <h2 id="section-datenschutzbeauftragter">II. Name und Anschrift des
                        Datenschutzbeauftragten</h2>
                    Der Datenschutzbeauftragte des Verantwortlichen ist:<br/><br/>
                    <address>
                        Martin Franz<br/>
                        Landesamt für Umwelt Rheinland-Pfalz<br/>
                        Kaiser-Friedrich-Straße 7<br/>
                        55116 Mainz / Rhein<br/><br/>
                    </address>
                    Telefon: 06131 - 6033 - 0<br/>
                    E-Mail: <a href="mailto:Martin.Franz@lfu.rlp.de"
                               aria-label="E-Mail an Martin.Franz@lfu.rlp.de senden">Martin.Franz@lfu.rlp.de</a><br/>
                    Website: <a href="https://www.lfu.rlp.de" target="_blank"
                                rel="noreferrer"
                                aria-label="Externe Website des LfU Rheinland-Pfalz">www.lfu.rlp.de</a><p/>
                </section>

                <section aria-labelledby="section-datenverarbeitung">
                    <h2 id="section-datenverarbeitung">III. Allgemeines zur Datenverarbeitung</h2>

                    <article>
                        <h3>1. Umfang der Verarbeitung personenbezogener Daten</h3>
                        <p>
                            Wir verarbeiten personenbezogene Daten unserer Nutzer grundsätzlich nur, soweit dies zur
                            Bereitstellung einer funktionsfähigen Website sowie unserer Inhalte und Leistungen
                            erforderlich
                            ist. Die Verarbeitung personenbezogener Daten unserer Nutzer erfolgt regelmäßig nur nach
                            Einwilligung des Nutzers. Eine Ausnahme gilt in solchen Fällen, in denen eine vorherige
                            Einholung einer Einwilligung aus tatsächlichen Gründen nicht möglich ist und die
                            Verarbeitung
                            der Daten durch gesetzliche Vorschriften gestattet ist.
                        </p>
                    </article>

                    <article>
                        <h3>2. Rechtsgrundlage für die Verarbeitung personenbezogener Daten</h3>
                        <p>
                            Soweit wir für Verarbeitungsvorgänge personenbezogener Daten eine Einwilligung der
                            betroffenen
                            Person einholen, dient Art. 6 Abs. 1 lit. a EU-Datenschutzgrundverordnung (DSGVO) als
                            Rechtsgrundlage.
                        </p>
                        <p>
                            Soweit eine Verarbeitung personenbezogener Daten zur Erfüllung einer rechtlichen
                            Verpflichtung
                            erforderlich ist, der das Landesamt für Umwelt unterliegt, dient Art. 6 Abs. 1 Satz 1
                            lit. c
                            i.
                            V. m. Art. 6 Abs. 3 Satz 1 lit. b DSGVO i. V. m. § 3 LDSG als Rechtsgrundlage.
                        </p>
                        <p>
                            Für den Fall, dass lebenswichtige Interessen der betroffenen Person oder einer anderen
                            natürlichen Person eine Verarbeitung personenbezogener Daten erforderlich machen, dient
                            Art.
                            6
                            Abs. 1 Satz 1 lit. d DSGVO als Rechtsgrundlage.
                        </p>
                        <p>
                            Ist die Verarbeitung zur Wahrnehmung einer Aufgabe des Landesamtes für Umwelt, die im
                            öffentlichen Interesse liegt oder in Ausübung öffentlicher Gewalt erfolgt, erforderlich, so
                            dient Art. 6 Abs. 3 Satz 1 lit. b DSGVO i.V. m. § 3 LDSG als Rechtsgrundlage für die
                            Verarbeitung.
                        </p>
                    </article>

                    <article>
                        <h3>3. Datenlöschung und Speicherdauer</h3>
                        <p>
                            Die personenbezogenen Daten der betroffenen Person werden gelöscht oder gesperrt, sobald
                            der
                            Zweck der Speicherung entfällt. Eine Speicherung kann darüber hinaus erfolgen, wenn dies
                            durch
                            den europäischen oder nationalen Gesetzgeber in unionsrechtlichen Verordnungen, Gesetzen
                            oder
                            sonstigen Vorschriften, denen der Verantwortliche unterliegt, vorgesehen wurde. Eine
                            Sperrung
                            oder Löschung der Daten erfolgt auch dann, wenn eine durch die genannten Normen
                            vorgeschriebene
                            Speicherfrist abläuft, es sei denn, dass eine Erforderlichkeit zur weiteren Speicherung
                            der
                            Daten für einen Vertragsabschluss oder eine Vertragserfüllung besteht.
                        </p>
                    </article>
                </section>

                <section aria-labelledby="section-logfiles">
                    <h2 id="section-logfiles">IV. Bereitstellung der Website und Erstellung
                        von Logfiles</h2>

                    <article>
                        <h3>1. Beschreibung und Umfang der Datenverarbeitung</h3>
                        Bei jedem Aufruf unserer Internetseite erfasst unser System automatisiert Daten und
                        Informationen
                        vom Computersystem des aufrufenden Rechners.
                        Folgende Daten werden hierbei erhoben:
                        <ol>
                            <li>Informationen über den Browsertyp und die verwendete Version</li>
                            <li>Das Betriebssystem des Nutzers</li>
                            <li>Die IP-Adresse des Nutzers</li>
                            <li>Datum und Uhrzeit des Zugriffs</li>
                        </ol>
                        <p>
                            Die Daten werden ebenfalls in den Logfiles unseres Systems gespeichert. Eine Speicherung
                            dieser
                            Daten zusammen mit anderen personenbezogenen Daten des Nutzers findet nicht statt.
                        </p>
                    </article>

                    <article>
                        <h3>2. Rechtsgrundlage für die Datenverarbeitung</h3>
                        <p>
                            Rechtsgrundlage für die vorübergehende Speicherung der Daten und der Logfiles ist Art. 6
                            Abs. 3
                            lit. b DSGVO i.V.m. § 3 LDSG.
                        </p>
                    </article>

                    <article>
                        <h3>3. Zweck der Datenverarbeitung</h3>
                        <p>
                            Die vorübergehende Speicherung der IP-Adresse durch das System ist notwendig, um eine
                            Auslieferung der Website an den Rechner des Nutzers zu ermöglichen. Hierfür muss die
                            IP-Adresse
                            des Nutzers für die Dauer der Sitzung gespeichert bleiben.
                        </p>
                        <p>
                            Die Speicherung in Logfiles erfolgt, um die Funktionsfähigkeit der Website
                            sicherzustellen.
                            Zudem dienen uns die Daten zur Optimierung der Website und zur Sicherstellung der
                            Sicherheit
                            unserer informationstechnischen Systeme. Eine Auswertung der Daten zu Marketingzwecken
                            findet
                            in diesem Zusammenhang nicht statt.
                        </p>
                        <p>
                            In diesen Zwecken liegt auch unser berechtigtes Interesse an der Datenverarbeitung nach
                            Art.
                            6
                            Abs. 1 lit. f DSGVO.
                        </p>
                    </article>

                    <article>
                        <h3>4. Dauer der Speicherung</h3>
                        <p>
                            Die Daten werden gelöscht, sobald sie für die Erreichung des Zweckes ihrer Erhebung
                            nicht
                            mehr
                            erforderlich sind. Im Falle der Erfassung der Daten zur Bereitstellung der Website ist
                            dies
                            der
                            Fall, wenn die jeweilige Sitzung beendet ist.
                        </p>
                        <p>
                            Im Falle der Speicherung der Daten in Logfiles erfolgt dies in der Regel nach sieben
                            Tagen.
                            Aus technischen Gründen ist eine begrenzte darüber hinausgehende Speicherung möglich.
                        </p>
                    </article>

                    <article>
                        <h3>5. Widerspruchs- und Beseitigungsmöglichkeit</h3>
                        <p>
                            Die Erfassung der Daten zur Bereitstellung der Website und die Speicherung der Daten in
                            Logfiles
                            ist für den Betrieb der Internetseite zwingend erforderlich. Es besteht folglich seitens
                            des
                            Nutzers keine Widerspruchsmöglichkeit.
                        </p>
                    </article>
                </section>

                <section aria-labelledby="section-cookies">
                    <h2 id="section-cookies">V. Verwendung von Cookies</h2>

                    <article>
                        <h3>a) Beschreibung und Umfang der Datenverarbeitung</h3>
                        <p>
                            Unsere Webseite verwendet Cookies. Bei Cookies handelt es sich um Textdateien, die im
                            Internetbrowser bzw. vom Internetbrowser auf dem Computersystem des Nutzers gespeichert
                            werden. Ruft ein Nutzer eine Website auf, so kann ein Cookie auf dem Betriebssystem des
                            Nutzers
                            gespeichert werden. Dieser Cookie enthält eine charakteristische Zeichenfolge, die eine
                            eindeutige Identifizierung des Browsers beim erneuten Aufrufen der Website ermöglicht.
                        </p>
                        <p>
                            Wir setzen Cookies ein, um unsere Website nutzerfreundlicher zu gestalten. Einige
                            Elemente
                            unserer Internetseite erfordern es, dass der aufrufende Browser auch nach einem
                            Seitenwechsel
                            identifiziert werden kann.
                        </p>
                    </article>

                    <article>
                        <h3>b) Rechtsgrundlage für die Datenverarbeitung</h3>
                        <p>
                            Rechtsgrundlage für die Verarbeitung der personenbezogenen Daten der Nutzer ist Art. 6 Abs.
                            3 lit. b DSGVO i.V.m. § 3 LDSG.
                        </p>
                    </article>

                    <article>
                        <h3>c) Zweck der Datenverarbeitung</h3>
                        <p>
                            Der Zweck der Verwendung technisch notwendiger Cookies ist, die Nutzung von Websites für die
                            Nutzer zu vereinfachen. Einige Funktionen unserer Internetseite können ohne den Einsatz von
                            Cookies nicht angeboten werden. Für diese ist es erforderlich, dass der Browser auch nach
                            einem Seitenwechsel wiedererkannt wird.
                        </p>
                        <p>
                            Die durch technisch notwendige Cookies erhobenen Nutzerdaten werden nicht zur Erstellung
                            von Nutzerprofilen verwendet
                        </p>
                        <p>
                            In diesen Zwecken liegt auch unser berechtigtes Interesse in der Verarbeitung der
                            personenbezogenen Daten nach Art. 6 Abs. 1 lit. f DSGVO.
                        </p>
                        <h3>d) Dauer der Speicherung, Widerspruchs- und Beseitigungsmöglichkeit</h3>
                        <p>
                            Cookies werden auf dem Rechner des Nutzers gespeichert und von diesem an unserer Seite
                            übermittelt. Daher haben Sie als Nutzer auch die volle Kontrolle über die Verwendung von
                            Cookies. Durch eine Änderung der Einstellungen in Ihrem Internetbrowser können Sie die
                            Übertragung von Cookies deaktivieren oder einschränken. Bereits gespeicherte Cookies
                            können
                            jederzeit gelöscht werden. Dies kann auch automatisiert erfolgen. Werden Cookies für
                            unsere
                            Website deaktiviert, können möglicherweise nicht mehr alle Funktionen der Website
                            vollumfänglich
                            genutzt werden.
                        </p>
                    </article>
                </section>

                <section aria-labelledby="section-email-kontakt">
                    <h2 id="section-email-kontakt">VI. E-Mail-Kontakt</h2>

                    <article>
                        <h3>1. Beschreibung und Umfang der Datenverarbeitung</h3>
                        <p>
                            Auf unserer Internetseite wird eine E-Mail-Adresse zur Kontaktaufnahme bereitgehalten, die
                            für die elektronische Kontaktaufnahme genutzt werden kann.
                        </p>
                        <p>
                            In diesem Fall werden die mit der E-Mail übermittelten personenbezogenen Daten des Nutzers
                            gespeichert.
                        </p>
                        <p>
                            Es erfolgt in diesem Zusammenhang keine Weitergabe der Daten an Dritte. Die Daten werden
                            ausschließlich für die Verarbeitung der Konversation verwendet.
                        </p>
                    </article>

                    <article>
                        <h3>2. Rechtsgrundlage für die Datenverarbeitung</h3>
                        <p>
                            Rechtsgrundlage für die Verarbeitung der Daten ist bei Vorliegen einer Einwilligung des
                            Nutzers
                            Art. 6 Abs. 1 lit. a DSGVO.
                        </p>
                        <p>
                            Rechtsgrundlage für die Verarbeitung der Daten, die im Zuge einer Übersendung einer
                            E-Mail
                            übermittelt werden, ist Art. 6 Abs. 1 lit. f DSGVO. Zielt der E-Mail-Kontakt auf den
                            Abschluss
                            eines Vertrages ab, so ist zusätzliche Rechtsgrundlage für die Verarbeitung Art. 6 Abs.
                            1
                            lit.
                            b DSGVO.
                        </p>
                    </article>

                    <article>
                        <h3>3. Zweck der Datenverarbeitung</h3>
                        <p>
                            Die Verarbeitung der personenbezogenen Daten dient uns allein zur Bearbeitung der
                            Kontaktaufnahme. Im Falle einer Kontaktaufnahme per E-Mail liegt hieran auch das
                            erforderliche berechtigte Interesse an der Verarbeitung der Daten.
                        </p>
                    </article>

                    <article>
                        <h3>4. Dauer der Speicherung</h3>
                        <p>
                            Die Daten werden gelöscht, sobald sie für die Erreichung des Zweckes ihrer Erhebung nicht
                            mehr erforderlich sind. Für die personenbezogenen Daten, die per E-Mail übersandt wurden,
                            ist dies dann der Fall, wenn die jeweilige Konversation mit dem Nutzer beendet ist. Beendet
                            ist die Konversation dann, wenn sich aus den Umständen entnehmen lässt, dass der betroffene
                            Sachverhalt abschließend geklärt ist.
                        </p>
                    </article>

                    <article>
                        <h3>5. Widerspruchs- und Beseitigungsmöglichkeit</h3>
                        <p>
                            Der Nutzer hat jederzeit die Möglichkeit, seine Einwilligung zur Verarbeitung der
                            personenbezogenen Daten zu widerrufen. Nimmt der Nutzer per E-Mail Kontakt mit uns auf,
                            so
                            kann
                            er der Speicherung seiner personenbezogenen Daten jederzeit widersprechen. In einem
                            solchen
                            Fall
                            kann die Konversation nicht fortgeführt werden.
                        </p>
                        <p>
                            Alle personenbezogenen Daten, die im Zuge der Kontaktaufnahme gespeichert wurden, werden
                            in
                            diesem Fall gelöscht.
                        </p>
                    </article>
                </section>

                <section aria-labelledby="section-rechte-betroffene-person">
                    <h2 id="section-rechte-betroffene-person">VII. Rechte der betroffenen
                        Person</h2>

                    <article>
                        <h3>1. Auskunftsrecht</h3>
                        <p>
                            Sie können von dem Verantwortlichen eine Bestätigung darüber verlangen, ob
                            personenbezogene
                            Daten, die Sie betreffen, von uns verarbeitet werden.
                        </p>
                        <p>
                            Liegt eine solche Verarbeitung vor, können Sie von dem Verantwortlichen über folgende
                            Informationen Auskunft verlangen:
                        </p>
                        <ol>
                            <li>die Zwecke, zu denen die personenbezogenen Daten verarbeitet werden;</li>
                            <li>die Kategorien von personenbezogenen Daten, welche verarbeitet werden;</li>
                            <li>die Empfänger bzw. die Kategorien von Empfängern, gegenüber denen die Sie
                                betreffenden
                                personenbezogenen Daten offengelegt wurden oder noch offengelegt werden;
                            </li>
                            <li>die geplante Dauer der Speicherung der Sie betreffenden personenbezogenen Daten
                                oder,
                                falls
                                konkrete Angaben hierzu nicht möglich sind, Kriterien für die Festlegung der
                                Speicherdauer;
                            </li>
                            <li>
                                das Bestehen eines Rechts auf Berichtigung oder Löschung der Sie betreffenden
                                personenbezogenen Daten, eines Rechts auf Einschränkung der Verarbeitung durch den
                                Verantwortlichen oder eines Widerspruchsrechts gegen diese Verarbeitung;
                            </li>
                            <li>
                                das Bestehen eines Beschwerderechts bei einer Aufsichtsbehörde;
                            </li>
                            <li>
                                alle verfügbaren Informationen über die Herkunft der Daten, wenn die
                                personenbezogenen
                                Daten
                                nicht bei der betroffenen Person erhoben werden;
                            </li>
                            <li>
                                das Bestehen einer automatisierten Entscheidungsfindung einschließlich Profiling
                                gemäß
                                Art. 22 Abs. 1 und 4 DSGVO und – zumindest in diesen Fällen – aussagekräftige
                                Informationen
                                über die involvierte Logik sowie die Tragweite und die angestrebten Auswirkungen
                                einer
                                derartigen Verarbeitung für die betroffene Person.
                            </li>
                        </ol>
                        <p>
                            Ihnen steht das Recht zu, Auskunft darüber zu verlangen, ob die Sie betreffenden
                            personenbezogenen Daten in ein Drittland oder an eine internationale Organisation
                            übermittelt
                            werden. In diesem Zusammenhang können Sie verlangen, über die geeigneten Garantien gem.
                            Art.
                            46
                            DSGVO im Zusammenhang mit der Übermittlung unterrichtet zu werden.
                        </p>
                    </article>

                    <article>
                        <h3>2. Recht auf Berichtigung</h3>
                        <p>
                            Sie haben ein Recht auf Berichtigung und/oder Vervollständigung gegenüber dem
                            Verantwortlichen,
                            sofern die verarbeiteten personenbezogenen Daten, die Sie betreffen, unrichtig oder
                            unvollständig sind. Der Verantwortliche hat die Berichtigung unverzüglich vorzunehmen.
                        </p>
                    </article>

                    <article>
                        <h3>3. Recht auf Einschränkung der Verarbeitung</h3>
                        <p>
                            Unter den folgenden Voraussetzungen können Sie die Einschränkung der Verarbeitung der
                            Sie
                            betreffenden personenbezogenen Daten verlangen:
                        </p>
                        <ol>
                            <li> wenn Sie die Richtigkeit der Sie betreffenden personenbezogenen für eine Dauer
                                bestreiten,
                                die es dem Verantwortlichen ermöglicht, die Richtigkeit der personenbezogenen Daten
                                zu
                                überprüfen;
                            </li>
                            <li>
                                die Verarbeitung unrechtmäßig ist und Sie die Löschung der personenbezogenen Daten
                                ablehnen
                                und stattdessen die Einschränkung der Nutzung der personenbezogenen Daten verlangen;
                            </li>
                            <li>
                                der Verantwortliche die personenbezogenen Daten für die Zwecke der Verarbeitung
                                nicht
                                länger
                                benötigt, Sie diese jedoch zur Geltendmachung, Ausübung oder Verteidigung von
                                Rechtsansprüchen benötigen, oder
                            </li>
                            <li>
                                wenn Sie Widerspruch gegen die Verarbeitung gemäß Art. 21 Abs. 1 DSGVO eingelegt
                                haben
                                und
                                noch nicht feststeht, ob die berechtigten Gründe des Verantwortlichen gegenüber
                                Ihren
                                Gründen überwiegen.
                            </li>
                        </ol>
                        <p>
                            Wurde die Verarbeitung der Sie betreffenden personenbezogenen Daten eingeschränkt,
                            dürfen
                            diese
                            Daten – von ihrer Speicherung abgesehen – nur mit Ihrer Einwilligung oder zur
                            Geltendmachung,
                            Ausübung oder Verteidigung von Rechtsansprüchen oder zum Schutz der Rechte einer anderen
                            natürlichen oder juristischen Person oder aus Gründen eines wichtigen öffentlichen
                            Interesses
                            der Union oder eines Mitgliedstaats verarbeitet werden.
                        </p>
                        <p>
                            Wurde die Einschränkung der Verarbeitung nach den o.g. Voraussetzungen eingeschränkt,
                            werden
                            Sie von dem Verantwortlichen unterrichtet bevor die Einschränkung aufgehoben wird.
                        </p>
                    </article>

                    <article>
                        <h3>4. Recht auf Löschung</h3>
                        <p>a) Löschungspflicht</p>
                        <p>
                            Sie können von dem Verantwortlichen verlangen, dass die Sie betreffenden
                            personenbezogenen
                            Daten
                            unverzüglich gelöscht werden, und der Verantwortliche ist verpflichtet, diese Daten
                            unverzüglich
                            zu löschen, sofern einer der folgenden Gründe zutrifft:
                        </p>
                        <ol>
                            <li>Die Sie betreffenden personenbezogenen Daten sind für die Zwecke, für die sie
                                erhoben
                                oder
                                auf sonstige Weise verarbeitet wurden, nicht mehr notwendig.
                            </li>
                            <li>Sie widerrufen Ihre Einwilligung, auf die sich die Verarbeitung gem. Art. 6 Abs.
                                1
                                lit.
                                a
                                oder Art. 9 Abs. 2 lit. a DSGVO stützte, und es fehlt an einer anderweitigen
                                Rechtsgrundlage
                                für die Verarbeitung.
                            </li>
                            <li>
                                Sie legen gem. Art. 21 Abs. 1 DSGVO Widerspruch gegen die Verarbeitung ein und
                                es
                                liegen
                                keine vorrangigen berechtigten Gründe für die Verarbeitung vor, oder Sie legen
                                gem.
                                Art.
                                21
                                Abs. 2 DSGVO Widerspruch gegen die Verarbeitung ein.
                            </li>
                            <li>
                                Die Sie betreffenden personenbezogenen Daten wurden unrechtmäßig verarbeitet.
                            </li>
                            <li>
                                Die Löschung der Sie betreffenden personenbezogenen Daten ist zur Erfüllung
                                einer
                                rechtlichen Verpflichtung nach dem Unionsrecht oder dem Recht der
                                Mitgliedstaaten
                                erforderlich, dem der Verantwortliche unterliegt.
                            </li>
                            <li>
                                Die Sie betreffenden personenbezogenen Daten wurden in Bezug auf angebotene
                                Dienste
                                der
                                Informationsgesellschaft gemäß Art. 8 Abs. 1 DSGVO erhoben.
                            </li>
                        </ol>


                        <p>b) Information an Dritte</p>
                        <p>
                            Hat der Verantwortliche die Sie betreffenden personenbezogenen Daten öffentlich gemacht
                            und
                            ist
                            er gem. Art. 17 Abs. 1 DSGVO zu deren Löschung verpflichtet, so trifft er unter
                            Berücksichtigung
                            der verfügbaren Technologie und der Implementierungskosten angemessene Maßnahmen, auch
                            technischer Art, um für die Datenverarbeitung Verantwortliche, die die personenbezogenen
                            Daten
                            verarbeiten, darüber zu informieren, dass Sie als betroffene Person von ihnen die
                            Löschung
                            aller
                            Links zu diesen personenbezogenen Daten oder von Kopien oder Replikationen dieser
                            personenbezogenen Daten verlangt haben.
                        </p>
                        <p>c) Ausnahmen</p>
                        <p>
                            Das Recht auf Löschung besteht nicht, soweit die Verarbeitung erforderlich ist
                        </p>
                        <ol>
                            <li>zur Ausübung des Rechts auf freie Meinungsäußerung und Information;</li>
                            <li>zur Erfüllung einer rechtlichen Verpflichtung, die die Verarbeitung nach dem Recht der
                                Union oder der Mitgliedstaaten, dem der Verantwortliche unterliegt, erfordert, oder zur
                                Wahrnehmung einer Aufgabe, die im öffentlichen Interesse liegt oder in Ausübung
                                öffentlicher Gewalt erfolgt, die dem Verantwortlichen übertragen wurde;
                            </li>
                            <li>aus Gründen des öffentlichen Interesses im Bereich der öffentlichen Gesundheit gemäß
                                Art. 9 Abs. 2 lit. h und i sowie Art. 9 Abs. 3 DSGVO;
                            </li>
                            <li>für im öffentlichen Interesse liegende Archivzwecke, wissenschaftliche oder
                                historische Forschungszwecke oder für statistische Zwecke gem. Art. 89 Abs. 1 DSGVO,
                                soweit das unter Abschnitt a) genannte Recht voraussichtlich die Verwirklichung der
                                Ziele dieser Verarbeitung unmöglich macht oder ernsthaft beeinträchtigt, oder
                            </li>
                            <li>
                                zur Geltendmachung, Ausübung oder Verteidigung von Rechtsansprüchen.
                            </li>
                        </ol>
                    </article>

                    <article>
                        <h3>5. Recht auf Unterrichtung</h3>
                        <p>Haben Sie das Recht auf Berichtigung, Löschung oder Einschränkung der Verarbeitung
                            gegenüber
                            dem
                            Verantwortlichen geltend gemacht, ist dieser verpflichtet, allen Empfängern, denen die
                            Sie
                            betreffenden personenbezogenen Daten offengelegt wurden, diese Berichtigung oder
                            Löschung
                            der
                            Daten oder Einschränkung der Verarbeitung mitzuteilen, es sei denn, dies erweist sich
                            als
                            unmöglich oder ist mit einem unverhältnismäßigen Aufwand verbunden.
                        </p>
                        <p>Ihnen steht gegenüber dem Verantwortlichen das Recht zu, über diese Empfänger
                            unterrichtet zu
                            werden.</p>
                    </article>

                    <article>
                        <h3>6. Recht auf Datenübertragbarkeit</h3>
                        <p>Sie haben das Recht, die Sie betreffenden
                            personenbezogenen Daten, die Sie dem Verantwortlichen bereitgestellt haben, in einem
                            strukturierten, gängigen und maschinenlesbaren Format zu erhalten. Außerdem haben Sie
                            das
                            Recht
                            diese Daten einem anderen Verantwortlichen ohne Behinderung durch den Verantwortlichen,
                            dem
                            die
                            personenbezogenen Daten bereitgestellt wurden, zu übermitteln, sofern

                        </p>
                        <ol>
                            <li>die Verarbeitung auf einer Einwilligung gem. Art. 6 Abs. 1 lit. a DSGVO oder
                                Art. 9
                                Abs. 2 lit. a DSGVO oder auf einem Vertrag gem. Art. 6 Abs. 1 lit. b DSGVO
                                beruht
                                und
                            </li>
                            <li>die Verarbeitung mithilfe automatisierter Verfahren erfolgt.</li>
                        </ol>
                        <p>
                            In Ausübung dieses Rechts haben Sie ferner das Recht, zu erwirken, dass die Sie
                            betreffenden
                            personenbezogenen Daten direkt von einem Verantwortlichen einem anderen Verantwortlichen
                            übermittelt werden, soweit dies technisch machbar ist. Freiheiten und Rechte anderer
                            Personen
                            dürfen hierdurch nicht beeinträchtigt werden.
                        </p>
                        <p>
                            Das Recht auf Datenübertragbarkeit gilt nicht für eine Verarbeitung personenbezogener
                            Daten,
                            die
                            für die Wahrnehmung einer Aufgabe erforderlich ist, die im öffentlichen Interesse liegt
                            oder
                            in
                            Ausübung öffentlicher Gewalt erfolgt, die dem Verantwortlichen übertragen wurde.
                        </p>
                    </article>

                    <article>
                        <h3>7. Widerspruchsrecht</h3>
                        <p>Sie haben das Recht, aus Gründen, die sich aus ihrer besonderen Situation ergeben,
                            jederzeit
                            gegen die Verarbeitung der Sie betreffenden personenbezogenen Daten, die aufgrund von
                            Art. 6
                            Abs. 1 lit. e oder f DSGVO erfolgt, Widerspruch einzulegen; dies gilt auch für ein auf
                            diese
                            Bestimmungen gestütztes Profiling.</p>
                        <p>Der Verantwortliche verarbeitet die Sie betreffenden personenbezogenen Daten nicht mehr,
                            es
                            sei
                            denn, er kann zwingende schutzwürdige Gründe für die Verarbeitung nachweisen, die Ihre
                            Interessen, Rechte und Freiheiten überwiegen, oder die Verarbeitung dient der
                            Geltendmachung,
                            Ausübung oder Verteidigung von Rechtsansprüchen.</p>
                        <p>Werden die Sie betreffenden personenbezogenen Daten verarbeitet, um Direktwerbung zu
                            betreiben,
                            haben Sie das Recht, jederzeit Widerspruch gegen die Verarbeitung der Sie betreffenden
                            personenbezogenen Daten zum Zwecke derartiger Werbung einzulegen; dies gilt auch für das
                            Profiling, soweit es mit solcher Direktwerbung in Verbindung steht.</p>
                        <p>Widersprechen Sie der Verarbeitung für Zwecke der Direktwerbung, so werden die Sie
                            betreffenden
                            personenbezogenen Daten nicht mehr für diese Zwecke verarbeitet.</p>
                        <p>Sie haben die Möglichkeit, im Zusammenhang mit der Nutzung von Diensten der
                            Informationsgesellschaft – ungeachtet der Richtlinie 2002/58/EG – Ihr Widerspruchsrecht
                            mittels
                            automatisierter Verfahren auszuüben, bei denen technische Spezifikationen verwendet
                            werden.</p>
                    </article>

                    <article>
                        <h3>8. Recht auf Widerruf der datenschutzrechtlichen Einwilligungserklärung</h3>
                        <p>Sie haben das Recht, Ihre datenschutzrechtliche
                            Einwilligungserklärung
                            jederzeit zu widerrufen. Durch den Widerruf der Einwilligung wird die Rechtmäßigkeit der
                            aufgrund der Einwilligung bis zum Widerruf erfolgten Verarbeitung nicht berührt.</p>
                    </article>

                    <article>
                        <h3>9. Automatisierte Entscheidung im Einzelfall einschließlich Profiling</h3>
                        <p>Sie haben das Recht, nicht einer ausschließlich auf einer automatisierten Verarbeitung –
                            einschließlich Profiling – beruhenden Entscheidung unterworfen zu werden, die Ihnen
                            gegenüber
                            rechtliche Wirkung entfaltet oder Sie in ähnlicher Weise erheblich beeinträchtigt. Dies
                            gilt
                            nicht, wenn die Entscheidung
                        </p>
                        <ol>
                            <li>
                                für den Abschluss oder die Erfüllung eines Vertrags zwischen Ihnen und dem
                                Verantwortlichen erforderlich ist,
                            </li>
                            <li>
                                aufgrund von Rechtsvorschriften der Union oder der Mitgliedstaaten, denen der
                                Verantwortliche unterliegt, zulässig ist und diese Rechtsvorschriften
                                angemessene
                                Maßnahmen zur Wahrung Ihrer Rechte und Freiheiten sowie Ihrer berechtigten
                                Interessen
                                enthalten oder
                            </li>
                            <li>mit Ihrer ausdrücklichen Einwilligung erfolgt.</li>
                        </ol>

                        <p>
                            Allerdings dürfen diese Entscheidungen nicht auf besonderen Kategorien personenbezogener
                            Daten
                            nach Art. 9 Abs. 1 DSGVO beruhen, sofern nicht Art. 9 Abs. 2 lit. a oder g DSGVO gilt
                            und
                            angemessene Maßnahmen zum Schutz der Rechte und Freiheiten sowie Ihrer berechtigten
                            Interessen
                            getroffen wurden.
                        </p>
                        <p>
                            Hinsichtlich der in (1) und (3) genannten Fälle trifft der Verantwortliche angemessene
                            Maßnahmen, um die Rechte und Freiheiten sowie Ihre berechtigten Interessen zu wahren,
                            wozu
                            mindestens das Recht auf Erwirkung des Eingreifens einer Person seitens des
                            Verantwortlichen,
                            auf Darlegung des eigenen Standpunkts und auf Anfechtung der Entscheidung gehört.
                        </p>
                    </article>

                    <article>
                        <h3>10. Recht auf Beschwerde bei einer Aufsichtsbehörde</h3>
                        <p>Unbeschadet eines anderweitigen verwaltungsrechtlichen oder gerichtlichen Rechtsbehelfs
                            steht
                            Ihnen das Recht auf Beschwerde bei einer Aufsichtsbehörde, insbesondere in dem
                            Mitgliedstaat
                            ihres Aufenthaltsorts, ihres Arbeitsplatzes oder des Orts des mutmaßlichen Verstoßes,
                            zu,
                            wenn
                            Sie der Ansicht sind, dass die Verarbeitung der Sie betreffenden personenbezogenen Daten
                            gegen
                            die DSGVO verstößt. </p>
                        <p>Die Aufsichtsbehörde, bei der die Beschwerde eingereicht wurde, unterrichtet den
                            Beschwerdeführer
                            über den Stand und die Ergebnisse der Beschwerde einschließlich der Möglichkeit eines
                            gerichtlichen Rechtsbehelfs nach Art. 78 DSGVO.</p>
                    </article>

                </section>

                <Button id="btn-zurueck-anmeldung" onClick={onZurueckClick} aria-label="Zurück zur Anmeldeseite">
                    Zurück zur Anmeldung
                </Button>
            </div>
        </main>
    );

    return (
        <div className="datenschutz-container white">
            {datenschutzContent}
        </div>
    );
}

export default Datenschutz;
